<script setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth.js'

const router = useRouter()
const authStore = useAuthStore()

const email = ref('')
const requestSubmitted = ref(false)
const isSubmitting = ref(false)

const isSubmitDisabled = computed(() => {
  return isSubmitting.value || authStore.loading || !email.value.trim()
})

const handleRequestReset = async () => {
  if (isSubmitting.value) return

  requestSubmitted.value = false
  isSubmitting.value = true

  try {
    await authStore.requestPasswordReset(email.value)
  } finally {
    isSubmitting.value = false
    requestSubmitted.value = true
  }
}
</script>

<template>
  <div class="forgot-password-container">
    <h1>Forgot Password</h1>

    <form @submit.prevent="handleRequestReset">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          v-model="email"
          type="email"
          required
          autocomplete="email"
          :disabled="isSubmitting"
        />
      </div>

      <button type="submit" :disabled="isSubmitDisabled">
        {{ isSubmitting ? 'Sending...' : 'Request Password Reset' }}
      </button>

      <div v-if="requestSubmitted" class="info">
        If account exists, email has been sent
      </div>

      <button type="button" class="secondary" :disabled="isSubmitting" @click="router.push('/login')">
        Back to Login
      </button>
    </form>
  </div>
</template>

<style scoped>
.forgot-password-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 2rem;
  border: 1px solid #ddd;
  border-radius: 8px;
}

h1 {
  text-align: center;
  color: #111827;
  margin-bottom: 2rem;
}

form {
  display: grid;
  gap: 1rem;
}

.form-group {
  display: grid;
  gap: 0.5rem;
}

label {
  color: #111827;
  font-weight: bold;
}

input[type='email'] {
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  color: #111827;
}

button {
  padding: 0.75rem;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}

button:hover:not(:disabled) {
  background-color: #1976d2;
}

button:disabled {
  background-color: #ccc;
}

.secondary {
  background-color: #6b7280;
}

.secondary:hover:not(:disabled) {
  background-color: #4b5563;
}

.info {
  background-color: #e8f5e9;
  color: #1b5e20;
  padding: 0.75rem;
  border-radius: 4px;
}
</style>
